import {Component, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AnzahlMitarbeitendeNachGrungesamtheit} from 'shared/dtos/cockpit/personalbestand';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';

@Component({
  selector: 'app-anzahl-mitarbeitende-nach-grungesamtheit',
  templateUrl: './anzahl-mitarbeitende-grundgesamtheit.component.html',
  styleUrls: [
    '../../../card/card.component.scss',
    '../../../../cockpit-shared/contents/cockpit-styles.scss'
  ],
  standalone: false
})
export class ChartDialogAnzahlMitarbeitendeNachGrungesamtheitComponent {
  @Input()
  anzahlMitarbeitendeNachGrundgesamtheit: AnzahlMitarbeitendeNachGrungesamtheit;
  @Input() tableHeader?: string;

  constructor(
    protected readonly tableExport: TableExportService,
    protected readonly translate: TranslateService
  ) {}

  exportTable() {
    this.tableExport.exportHtmlTable(
      'anzahlMitarbeitendeGrundgesamtheit',
      this.tableHeader
    );
  }
}
